
import {Input} from '@angular/core';
export class Topicdetails {

  @Input()
  description: string;
  subject: string;
  topic: string;
  year: string;
  duration: number;
  source: string;
  language: string;
  tags: string;
  status: string;


}